import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollReveal from "@/components/base/ScrollReveal";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import AboutSEO from "./components/AboutSEO";
import FeatureGrid from "./components/FeatureGrid";
import CategoriesSection from "./components/CategoriesSection";
import ArticlesSection from "./components/ArticlesSection";
import Testimonials from "./components/Testimonials";
import CTAFinal from "./components/CTAFinal";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <ScrollReveal>
          <CategoryGrid />
        </ScrollReveal>
        <ScrollReveal delay={100}>
          <AboutSEO />
        </ScrollReveal>
        <ScrollReveal delay={100}>
          <FeatureGrid />
        </ScrollReveal>
        <ScrollReveal delay={100}>
          <CategoriesSection />
        </ScrollReveal>
        <ScrollReveal delay={100}>
          <ArticlesSection />
        </ScrollReveal>
        <ScrollReveal delay={150}>
          <Testimonials />
        </ScrollReveal>
        <ScrollReveal delay={100}>
          <CTAFinal />
        </ScrollReveal>
      </main>
      <Footer />
    </>
  );
}